import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import {
  fetchGetQuestions,
  TGetQuestionsRequest,
  TGetQuestionsResponse,
} from '../../repositories/newbuilding-reviews/v1/get-questions';
import { prepareQuestions } from '../../mappers/prepareQuestions';

export interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: TGetQuestionsRequest;
}

export async function fetchQuestions({ httpApi, parameters }: IFetchReviewsParams) {
  const result: TGetQuestionsResponse = await fetchGetQuestions({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'questions#fetchQuestions',
      message: result.response.message as string,
    });
  }

  return prepareQuestions(result.response);
}
